import { CLEAR_GUID_VALUE } from '../../services/matterPayloadUtils';
angular.module('leanlaw').controller('InvoiceTemplateModalController', ['$scope', 'close', 'details', 'invoiceTemplates', 'selectedInvoiceTemplate', 'matter', 'me', 'alerts', 'leanLawApi', function ($scope, close, details, invoiceTemplates, selectedInvoiceTemplate, matter, me, alerts, leanLawApi) {
  $scope.invoiceTemplates = invoiceTemplates;
  $scope.details = details;
  $scope.selectedInvoiceTemplate = selectedInvoiceTemplate;
  $scope.updateInvoiceTemplateForClient = false;
  $scope.matter = matter;
  $scope.me = me;
  $scope.confirm = function () {
    $scope.saving = true;
    leanLawApi.updateMatter({
      id: $scope.matter.id,
      body: {
        updateInvoiceTemplateForClient: $scope.updateInvoiceTemplateForClient,
        // A missing invoiceTemplateId means "leave it untouched" on the backend,
        // so an explicit clear sentinel is required to remove the template.
        invoiceTemplateId: $scope.selectedInvoiceTemplate?.invoiceTemplateId ?? CLEAR_GUID_VALUE
      }
    }).then(matter => {
      if ($scope.selectedInvoiceTemplate) {
        alerts.success(`The Invoice Template updated  successfully.`);
      } else {
        alerts.success('The Invoice Template removed successfully.');
      }
      close(matter);
    }).catch(err => {
      alerts.error(err);
    }).finally(() => {
      $scope.saving = false;
    });
  };
  $scope.reject = function () {
    close(false);
  };
}]);